import { defineWave } from '../schema';

/** BOSS — L'ARRIVÉE DE LA NAVETTE.
 *
 *  Cinq secondes de silence avant l'apparition, exactement comme au monde 1 :
 *  c'est ce vide qui fait exister un boss (PLAN.md §6.6). Le dispositif est
 *  reproduit à l'identique parce qu'il est devenu une CONVENTION du jeu — le
 *  joueur a appris au monde 1 que le silence annonce quelque chose, et cette
 *  attente est maintenant un outil dont on dispose gratuitement.
 *
 *  Couloir 3, le centre, pour les deux mêmes raisons qu'au monde 1 : le registre
 *  refuse tout ennemi de plus de 200 PV dans les couloirs de bord, et la
 *  traversée du boss ne veut rien dire tant que le joueur ne l'a pas d'abord vu
 *  immobile au milieu. La première chose qu'il doit lire, c'est la silhouette ;
 *  la seconde, c'est qu'elle se met à balayer.
 *
 *  ⚠️ 108 s, largement au-delà des 45 à 60 s de combat attendus. La marge est
 *  volontaire : `levelSystem` ne sait pas qu'un boss est mort, il ne connaît que
 *  des horloges. Une durée trop courte ne raccourcirait pas le combat — elle
 *  ferait démarrer le bloc suivant PAR-DESSUS. */
export default defineWave({
  id: 'boss-navette',
  duration: 108,
  spawns: [{ at: 5.0, enemy: 'navette', lane: 3, count: 1, spacing: 0 }],
});
